import {useQuery} from 'react-query'
 import {CarEditModalForm} from './CarEditModalForm'
//  import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
 import {getCarById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const CarEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: car,
    error,
  } = useQuery(
    `${QUERIES.CARS_LIST}-car-${itemIdForUpdate}`,
    () => {
      return getCarById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
       // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <CarEditModalForm isCarLoading={false} car={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <CarEditModalForm isCarLoading={false} car={dataresponse} />
  }

  return null
}

export {CarEditModalFormWrapper}
